// create a new component called WorkflowListItem
// this component will be used to display a single workflow item

import { Expand, ExpandLess, ExpandMore, Delete } from "@mui/icons-material";
import { Box, IconButton, Paper } from "@mui/material";
import { Workflow } from "model/Workflow";
import { WorkflowTask } from "model/WorkflowTask";
import { useEffect, useState } from "react";
import "style/workflow.scss";
import { WorkflowTaskList } from "./workflowTaskList";
import { getWorkflowTasks, deleteWorkflow } from "services/workflowApiCaller";
import { ShowStatus } from "components/common/commonComponent";

interface WorkflowItemProps {
  workflow: Workflow;
  onDelete?: (id: string) => void;
}

export function WorkflowItem(props: WorkflowItemProps) {
  const [expanded, setExpanded] = useState(false);
  const[workflowTasks, setWorkflowTasks] = useState([] as WorkflowTask[]);

  useEffect(() => {
    if(expanded){
        getWorkflowTasks(props.workflow.id).then((result) => {
            setWorkflowTasks(result);
            }
        );
    }
  }, [expanded]);

  function handleExpandClick() {
    setExpanded(!expanded);
  }

  async function handleDelete() {
    if (window.confirm(`Êtes-vous sûr de vouloir supprimer le workflow "${props.workflow.label}" ?`)) {
      try {
        await deleteWorkflow(props.workflow.id!);
        if (props.onDelete) {
          props.onDelete(props.workflow.id!);
        }
      } catch (error) {
        console.error('[WorkflowItem] Erreur lors de la suppression:', error);
        alert('Erreur lors de la suppression du workflow');
      }
    }
  }

  return (
    <Paper className="workflowListItemPaper">
        <div className="workflowListItemContainer">
      <IconButton onClick={handleExpandClick}>
        {expanded ? <ExpandLess /> : <ExpandMore />}
      </IconButton>
      <div className="workflowListItemTitle">{props.workflow.label}</div>
      <Box sx={{ flexGrow: 1 }} />
      <div className="workflowListItemStatus">
          {ShowStatus(props.workflow)}</div>
      <IconButton 
        onClick={handleDelete}
        size="small"
        sx={{ color: 'error.main' }}
        title="Supprimer le workflow"
      >
        <Delete fontSize="small" />
      </IconButton>
      </div>
      {expanded ? <WorkflowTaskList workflowTasks={workflowTasks} /> : <></>}
    </Paper>
  );
}
